// ============================================================================
// LEDGER POSTING (Fairbooks posting register) API TYPES
// ============================================================================
// Matches crs.Core/DTOs/IntegrationModule/IntegrationOutboxDto.cs

/** One queued or completed outbound posting — integration.tbl_integration_outbox. */
export interface LedgerPosting {
  id: string;
  integrationType: string;   // 'FAIRBOOKS_RECEIPT'
  sourceType: string;        // 'PAYMENT' | 'PAYMENT_VOID'
  sourceId: string;          // booking.tbl_payment.id
  /** The JSON actually sent — frozen at enqueue so a retry re-sends identical bytes. */
  requestPayload?: string;
  /** Raw provider response, for audit and troubleshooting. */
  responsePayload?: string;
  /** Identifier Fairbooks assigned to the accepted document. */
  externalReference?: string;
  correlationId?: string;
  /** Cross-system dedupe key — travels as the receipt's reference number. */
  idempotencyKey?: string;
  attemptCount: number;
  nextAttemptAt?: string;
  lastAttemptAt?: string;
  processedAt?: string;
  lastError?: string;
  /** PENDING / PUBLISHED / POSTED / FAILED / MANUAL_REVIEW / SKIPPED */
  status: string;
  rowVersion: number;
  createdAt?: string;
  updatedAt?: string;
  totalCount: number;
}

export interface LedgerPostingSearchRequest {
  page?: number;
  pageSize?: number;
  searchTerm?: string;
  status?: string;
  sourceType?: string;
  integrationType?: string;
  createdFrom?: string;
  createdTo?: string;
}

export const LEDGER_POSTING_STATUSES = [
  'PENDING',
  'PUBLISHED',
  'POSTED',
  'FAILED',
  'MANUAL_REVIEW',
  'SKIPPED',
] as const;
